// QuoteEstimatePage.jsx
import { useState } from 'react';
import { MainWrap } from '../../utilities/Shared';

export default function QuoteEstimatePage() {
  const [activeTab, setActiveTab] = useState('press');
  const [activeComponent, setActiveComponent] = useState(1);

  const components = [
    { id: 1, name: 'Cover' },
    { id: 2, name: 'Text' },
    { id: 3, name: 'Insert' },
  ];

  return (
    <MainWrap>
    <div className="min-h-screen bg-gray-50 p-6 font-sans">
      {/* Header */}
      <header className="mb-8">
        <div className="flex items-center justify-between">
          <div>
            <h1 className="text-4xl font-bold text-teal-800">
              Quote <span className="text-teal-600">#______</span>
            </h1>
            <p className="text-gray-600 mt-1">Entered: ________</p>
          </div>
          <button className="px-5 py-2 bg-teal-700 text-white rounded-md hover:bg-teal-800 transition">
            Copy Quote
          </button>
        </div>
      </header>

      {/* Top Info Section */}
      <section className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-6">
          <div>
            <label className="block text-teal-700 font-semibold mb-1.5">Customer</label>
            <input type="text" className="w-full border border-teal-200 rounded px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent" />
          </div>
          <div className="md:col-span-2">
            <label className="block text-teal-700 font-semibold mb-1.5">Project</label>
            <input type="text" className="w-full border border-teal-200 rounded px-4 py-2.5 focus:outline-none focus:ring-2 focus:ring-teal-400 focus:border-transparent" />
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-5 gap-6">
          <div>
            <label className="block text-teal-700 font-semibold mb-1.5">Contact</label>
            <select className="w-full border border-teal-200 rounded px-4 py-2.5">
              <option>Select...</option>
            </select>
          </div>
          <div>
            <label className="block text-teal-700 font-semibold mb-1.5">Sales Rep</label>
            <select className="w-full border border-teal-200 rounded px-4 py-2.5">
              <option>Select...</option>
            </select>
          </div>
          <div>
            <label className="block text-teal-700 font-semibold mb-1.5">CSR</label>
            <select className="w-full border border-teal-200 rounded px-4 py-2.5">
              <option>Select...</option>
            </select>
          </div>
          <div>
            <label className="block text-teal-700 font-semibold mb-1.5">Due Date</label>
            <input type="date" className="w-full border border-teal-200 rounded px-4 py-2.5" />
          </div>
          <div>
            <label className="block text-teal-700 font-semibold mb-1.5">Priority</label>
            <select className="w-full border border-teal-200 rounded px-4 py-2.5">
              <option>Standard</option>
              <option>ASAP</option>
              <option>Hot</option>
            </select>
          </div>
        </div>

        {/* Quantities */}
        <div className="mt-8">
          <div className="flex items-center justify-between mb-4">
            <h3 className="text-xl font-bold text-teal-700">Quantities</h3>
            <div className="flex gap-4">
              <button className="flex items-center gap-1 text-green-600 hover:text-green-800">
                <span>+</span> Add
              </button>
              <button className="flex items-center gap-1 text-red-600 hover:text-red-800">
                <span>−</span> Delete
              </button>
            </div>
          </div>
          <div className="flex flex-wrap gap-4">
            {/* Quantity inputs / chips would render here */}
            <div className="bg-teal-50 border border-teal-200 rounded px-4 py-2 min-w-[120px] text-center">
              1,000
            </div>
            {/* ... more ... */}
          </div>
        </div>
      </section>

      {/* Main Tabs */}
      <section className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
        <nav className="flex border-b border-gray-200 bg-gray-50 px-1">
          {[
            { id: 'press', label: 'Press' },
            { id: 'components', label: 'Components' },
            { id: 'bindery', label: 'Bindery' },
            { id: 'mailing', label: 'Mailing' },
            { id: 'osp', label: 'OSP' },
            { id: 'cost-summary', label: 'Cost Summary' },
          ].map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                px-6 py-3 font-medium transition-colors rounded-t-lg
                ${activeTab === tab.id
                  ? 'bg-white border border-gray-200 border-b-white text-teal-700 -mb-px'
                  : 'text-gray-600 hover:bg-gray-100'
                }
              `}
            >
              {tab.label}
            </button>
          ))}
        </nav>

        <div className="p-6">
          {/* ────────────── Press Tab ────────────── */}
          {activeTab === 'press' && (
            <>
              {/* Component sub-tabs */}
              <div className="flex flex-wrap gap-2 mb-6 border-b pb-4">
                {components.map((comp, idx) => (
                  <button
                    key={comp.id}
                    onClick={() => setActiveComponent(idx + 1)}
                    className={`
                      px-5 py-2.5 rounded-t-lg font-medium text-sm relative
                      ${activeComponent === idx + 1
                        ? 'bg-white border border-gray-300 border-b-white text-teal-700 shadow-sm'
                        : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
                      }
                    `}
                  >
                    {comp.name}
                  </button>
                ))}
              </div>

              {/* Active component detail */}
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Component Name</label>
                  <input type="text" className="w-full border rounded px-4 py-2.5" defaultValue="Cover" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Paper</label>
                  <input type="text" list="paper-list" className="w-full border rounded px-4 py-2.5" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Front Inks</label>
                  <input type="text" className="w-full border rounded px-4 py-2.5 uppercase" />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Press</label>
                  <select className="w-full border rounded px-4 py-2.5">
                    <option>Select press...</option>
                  </select>
                </div>
                {/* Add more fields: Back Inks, Coatings, Method, Versions, Pages, Sheet Size, etc. */}
              </div>

              {/* Layout preview area */}
              <div className="mt-8 grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="border rounded-lg p-4 bg-white min-h-[340px] flex items-center justify-center text-gray-400">
                  Parent Sheet Layout Preview
                </div>
                <div className="border rounded-lg p-4 bg-white min-h-[340px] flex items-center justify-center text-gray-400">
                  Press Sheet Layout Preview
                </div>
              </div>
            </>
          )}

          {/* ────────────── Components / Bindery Tab ────────────── */}
          {activeTab === 'components' && (
            <div className="space-y-6">
              {components.map((comp) => (
                <div key={comp.id} className="border rounded-lg overflow-hidden bg-gray-50">
                  <div className="bg-teal-700 text-white px-5 py-3 font-medium flex justify-between items-center">
                    <span>{comp.name}</span>
                    <div className="flex gap-3">
                      <button className="text-white/90 hover:text-white">+</button>
                      <button className="text-white/90 hover:text-red-200">×</button>
                    </div>
                  </div>
                  <div className="p-6 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6">
                    <div>
                      <label className="block text-sm mb-1.5">Cuts</label>
                      <input type="text" className="w-full border rounded px-4 py-2.5" />
                    </div>
                    <div>
                      <label className="block text-sm mb-1.5">Fold Type</label>
                      <select className="w-full border rounded px-4 py-2.5">
                        <option>Letter Fold</option>
                        <option>Z Fold</option>
                        <option>Roll Fold</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm mb-1.5">Die Cut</label>
                      <select className="w-full border rounded px-4 py-2.5">
                        <option>None</option>
                        <option>Standard Die</option>
                        <option>Custom Die</option>
                      </select>
                    </div>
                    <div>
                      <label className="block text-sm mb-1.5">Round Corner</label>
                      <select className="w-full border rounded px-4 py-2.5">
                        <option>—</option>
                        <option>1/8"</option>
                        <option>1/4"</option>
                      </select>
                    </div>
                    {/* more bindery fields: drilling, duplo, hand work, notes... */}
                  </div>
                </div>
              ))}
            </div>
          )}

          {/* ────────────── Cost Summary Tab (example) ────────────── */}
          {activeTab === 'cost-summary' && (
            <div className="space-y-10">
              <div>
                <h3 className="text-2xl font-bold text-teal-800 mb-5">Paper Costs</h3>
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
                  {/* Paper cost breakdown cards */}
                  <div className="border rounded-lg p-5 bg-white shadow-sm">
                    <h4 className="font-semibold text-teal-700 mb-3">Cover</h4>
                    {/* details */}
                  </div>
                </div>
              </div>

              <div>
                <h3 className="text-2xl font-bold text-teal-800 mb-5">Labor</h3>
                <div className="space-y-6">
                  <div className="border-l-4 border-teal-600 pl-5">
                    <h4 className="font-semibold">Press</h4>
                    {/* press labor breakdown */}
                  </div>
                  <div className="border-l-4 border-teal-600 pl-5">
                    <h4 className="font-semibold">Cutting / Folding / Bindery</h4>
                    {/* ... */}
                  </div>
                </div>
              </div>

              {/* Materials, OSP, Mailing, Shipping sections similarly */}
            </div>
          )}

          {/* Other tabs (Mailing, OSP, etc.) follow similar pattern */}
        </div>
      </section>

      {/* Final Quote Actions & Notes */}
      <footer className="mt-12 bg-white p-8 rounded-lg shadow-sm border border-gray-200">
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10">
          <div className="lg:col-span-2">
            <h3 className="text-xl font-bold text-teal-800 mb-4">Quote Notes / Description</h3>
            <textarea
              className="w-full h-64 border border-gray-300 rounded-lg p-4 focus:outline-none focus:ring-2 focus:ring-teal-400 resize-none"
              placeholder="Full job description, specs, special instructions..."
            />
          </div>

          <div>
            <h3 className="text-xl font-bold text-teal-800 mb-4">Final Pricing</h3>
            <div className="space-y-4">
              <div className="flex justify-between text-lg">
                <span>Total (Qty 1):</span>
                <span className="font-bold text-teal-700">$____.__</span>
              </div>
              <div className="flex justify-between text-lg">
                <span>Total (Add'l):</span>
                <span className="font-bold text-teal-700">$____.__</span>
              </div>
              <hr className="my-4" />
              <div className="flex justify-between text-xl font-bold">
                <span>Grand Total:</span>
                <span className="text-teal-800">$____.__</span>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-10 flex justify-end gap-4">
          <button className="px-6 py-3 bg-gray-600 text-white rounded-md hover:bg-gray-700">
            Save Draft
          </button>
          <button className="px-8 py-3 bg-teal-700 text-white rounded-md hover:bg-teal-800 font-semibold">
            Submit for Approval
          </button>
        </div>
      </footer>
    </div>
    </MainWrap>
  );
}